import type { Policy } from '@cartwhl/common/appletPolicy';

import BmmPrototype from './components/MotionEditor';
import { withProvider } from './motionEditorStore';

const BmmPrototypeWithStore = withProvider(BmmPrototype);

const applet = {
  id: 'bmm-prototype',
  path: '/bmm-prototype',
  paths: ['/bmm-prototype'],
  label: 'BMM Prototype',
  description: 'Constraint-based motion editing',
  dashboard: {
    title: 'BMM Prototype',
    description: 'Constraint-based motion editing.',
    order: 70,
  },
  policy: {
    requiresLoggedIn: true,
    requiresApiKey: true,
    requiresAdmin: true,
  } satisfies Policy,
  component: BmmPrototypeWithStore,
};

export default applet;
